// Display helpers shared by list pages (portal shows "-" for empty values)
export const dash = (v) => (v === null || v === undefined || v === '' ? '-' : v);

export const money = (v) => (v === null || v === undefined ? '-' :
    '₹' + Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

// Portal shows validity as "<n> Days" (0 => "-")
export const days = (v) => (v ? `${v} Days` : '-');

// "yyyy-MM-dd" for API date filters (Sessions, Plan Purchase History)
export const apiDate = (d) => {
    const date = new Date(d);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${mm}-${dd}`;
};

// Portal default filter range: 1st of current month -> today
export const monthStart = () => {
    const d = new Date();
    return apiDate(new Date(d.getFullYear(), d.getMonth(), 1));
};
